// 📁 src/components/LoginLogs.js
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { getAuth } from "firebase/auth";

const LoginLogs = () => {
  const [logs, setLogs] = useState([]);
  const [filterEmail, setFilterEmail] = useState("");
  const [authEmail, setAuthEmail] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) setAuthEmail(user.email);
    });

    const fetchLogs = async () => {
      const qy = query(collection(db, "logins"), orderBy("loginTime", "desc"));
      const snapshot = await getDocs(qy);
      const logsData = snapshot.docs.map((doc) => {
        const d = doc.data() || {};
        return {
          id: doc.id,
          email: d.email || "-",
          ip: d.ip || "-",
          deviceInfo: d.deviceInfo || "-",
          deviceType: d.deviceType || "Bilinmiyor",
          fingerprint: d.fingerprint || "-",
          loginTime: d.loginTime?.toDate ? d.loginTime.toDate() : (d.loginTime ? new Date(d.loginTime) : null),
          logoutTime: d.logoutTime?.toDate ? d.logoutTime.toDate() : (d.logoutTime ? new Date(d.logoutTime) : null),
        };
      });
      setLogs(logsData);
    };

    fetchLogs();
    return () => unsubscribe();
  }, []);

  const filteredLogs = logs.filter((log) =>
    [log.email, log.ip, log.deviceInfo, log.deviceType, log.fingerprint]
      .join(" ").toLowerCase()
      .includes(filterEmail.toLowerCase())
  );

  const formatDate = (date) => date ? new Date(date).toLocaleString("tr-TR") : "-";

  const formatDuration = (log) => {
    if (!log.loginTime) return "-";
    if (!log.logoutTime) return "Sistemde";
    const durationMs = log.logoutTime - log.loginTime;
    const totalSeconds = Math.floor(durationMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;
  };

  if (authEmail !== "c.caliskan@inosel.com.tr") {
    return <div style={{ padding: 20, color: "red" }}>Bu sayfaya erişim izniniz yok.</div>;
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Giriş Logları</h2>
      <input
        type="text"
        placeholder="E-posta / IP / fingerprint ile filtrele"
        value={filterEmail}
        onChange={(e) => setFilterEmail(e.target.value)}
        style={{ padding: 6, marginBottom: 12, width:"100%", maxWidth:400 }}
      />
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ backgroundColor: "#1e293b", color: "white" }}>
          <tr>
            <th style={th}>E-posta</th>
            <th style={th}>IP</th>
            <th style={th}>Fingerprint</th>
            <th style={th}>Cihaz Bilgisi</th>
            <th style={th}>Cihaz Türü</th>
            <th style={th}>Giriş</th>
            <th style={th}>Çıkış</th>
            <th style={th}>Süre</th>
          </tr>
        </thead>
        <tbody>
          {filteredLogs.map((log) => (
            <tr key={log.id}>
              <td style={td}>{log.email}</td>
              <td style={td}>{log.ip}</td>
              <td style={td}>{log.fingerprint}</td>
              <td style={td}>{log.deviceInfo}</td>
              <td style={td}>{log.deviceType}</td>
              <td style={td}>{formatDate(log.loginTime)}</td>
              <td style={td}>{formatDate(log.logoutTime)}</td>
              <td style={td}>{formatDuration(log)}</td>
            </tr>
          ))}
          {!filteredLogs.length && (
            <tr><td colSpan={8} style={{ padding:10, color:"#64748b" }}>(Kayıt yok)</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const th = { border: "1px solid #ccc", padding: 8, textAlign:"left" };
const td = { border: "1px solid #ccc", padding: 8, textAlign:"left" };

export default LoginLogs;
